<template>
    <v-card-text>
        <v-row dense align="center">
            <v-col cols="12" sm="4" md="3">
                <v-select v-model="filtros.tipo" :items="TIPOS" label="Tipo de video" outlined dense hide-details clearable/>
            </v-col>
            <v-col cols="6" sm="4" md="2">
                <v-text-field v-model="filtros.desde" label="Desde" type="date" outlined dense hide-details clearable/>
            </v-col>
            <v-col cols="6" sm="4" md="2">
                <v-text-field v-model="filtros.hasta" label="Hasta" type="date" outlined dense hide-details clearable/>
            </v-col>
            <v-col cols="12" md="5" class="d-flex align-center justify-md-end">
                <span class="text-caption grey--text text--darken-1 mr-3">Las columnas de 7 y 30 días cuentan inicios desde hoy, sin importar el rango.</span>
                <v-btn color="info" small outlined :loading="cargando" title="Aplicar filtros y actualizar" @click="cargar"><v-icon small>refresh</v-icon></v-btn>
            </v-col>
        </v-row>

        <!-- Cifras -->
        <v-row dense class="mt-3">
            <v-col v-for="c in cifras" :key="c.etiqueta" cols="6" sm="4" md="2">
                <v-card outlined class="cifra">
                    <v-icon color="primary" class="cifra__icono">{{ c.icono }}</v-icon>
                    <div class="cifra__valor">{{ c.valor | numero }}</div>
                    <div class="cifra__etiqueta">{{ c.etiqueta }}</div>
                </v-card>
            </v-col>
        </v-row>

        <v-data-table
            dense
            class="mt-4"
            :headers="encabezados"
            :items="filas"
            :loading="cargando"
            item-key="video_id"
            :items-per-page="15"
            :footer-props="$store.state.footerPropsTable"
        >
            <template v-slot:[`item.titulo`]="{ item }">
                <div class="font-weight-medium">{{ item.titulo }}</div>
                <div class="text-caption grey--text">{{ item.tipo_texto }} · {{ item.fuente === 'youtube' ? 'YouTube' : 'Archivo MP4' }}</div>
            </template>
            <template v-slot:[`item.activo`]="{ item }">
                <v-chip x-small label :color="item.activo ? 'success' : 'grey'" text-color="white">{{ item.activo ? 'Publicado' : 'Inactivo' }}</v-chip>
            </template>
            <template v-slot:[`item.inicios`]="{ item }">{{ item.inicios | numero }}</template>
            <template v-slot:[`item.finalizaciones`]="{ item }">
                {{ item.finalizaciones | numero }}
                <span class="text-caption grey--text" v-if="item.porcentaje_fin !== null">({{ item.porcentaje_fin }} %)</span>
            </template>
            <template v-slot:[`item.personas`]="{ item }">{{ item.personas | numero }}</template>
            <template v-slot:[`item.mostrado`]="{ item }">
                <span v-if="item.tipo === 'promocional'">{{ item.mostrado | numero }}</span>
                <span v-else class="grey--text">—</span>
            </template>
            <template v-slot:[`item.ultimos_7`]="{ item }">{{ item.ultimos_7 | numero }}</template>
            <template v-slot:[`item.ultimos_30`]="{ item }">{{ item.ultimos_30 | numero }}</template>
            <template v-slot:no-data>
                <v-alert dense type="info" outlined class="text-center mt-3">No hay videos publicados con esos filtros.</v-alert>
            </template>
        </v-data-table>
    </v-card-text>
</template>

<script>
/** Pestaña Estadísticas: reproducciones por video (inicios, finalizaciones, personas únicas, últimos 7 y 30 días). */
export default {
    name: "VideosEstadisticas",
    props: {
        // Se carga al entrar a la pestaña por primera vez.
        activa: {type: Boolean, default: false},
    },
    data() {
        return {
            TIPOS: [
                {text: "Predeterminado", value: "predeterminado"},
                {text: "Felicitación", value: "felicitacion"},
                {text: "Promocional", value: "promocional"},
            ],
            cargando: false,
            cargado: false,
            filtros: {tipo: null, desde: null, hasta: null},
            filas: [],
            totales: null,
            encabezados: [
                {text: "Video", value: "titulo"},
                {text: "Estado", value: "activo", sortable: false},
                {text: "Inicios", value: "inicios", align: "end"},
                {text: "Finalizaciones", value: "finalizaciones", align: "end"},
                {text: "Personas", value: "personas", align: "end"},
                {text: "Veces ofrecido", value: "mostrado", align: "end"},
                {text: "Últimos 7 días", value: "ultimos_7", align: "end"},
                {text: "Últimos 30 días", value: "ultimos_30", align: "end"},
            ],
        }
    },
    computed: {
        cifras() {
            const t = this.totales;
            if (!t) return [];
            return [
                {icono: "movie", valor: t.videos, etiqueta: "Videos"},
                {icono: "play_circle", valor: t.inicios, etiqueta: "Inicios"},
                {icono: "task_alt", valor: t.finalizaciones, etiqueta: "Finalizaciones"},
                {icono: "group", valor: t.personas, etiqueta: "Personas únicas"},
                {icono: "today", valor: t.ultimos_7, etiqueta: "Últimos 7 días"},
                {icono: "date_range", valor: t.ultimos_30, etiqueta: "Últimos 30 días"},
            ];
        },
    },
    watch: {
        activa(valor) {
            if (valor && !this.cargado) this.cargar();
        },
    },
    methods: {
        cargar() {
            this.cargando = true;
            const params = {};
            Object.keys(this.filtros).forEach(k => {
                if (this.filtros[k]) params[k] = this.filtros[k];
            });

            window.axios.get("/videos/estadisticas", {params}).then(response => {
                if (response.data.success) {
                    this.filas = response.data.data.filas;
                    this.totales = response.data.data.totales;
                    this.cargado = true;
                } else {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    const cuerpo = error.response && error.response.data;
                    this.$toast.error((cuerpo && cuerpo.message) || "No se pudieron calcular las estadísticas.");
                })
                .finally(() => {
                    this.cargando = false;
                });
        },
    },
    created() {
        if (this.activa) this.cargar();
    },
}
</script>

<style lang="scss" scoped>
.cifra {
    padding: 12px 14px;
    border-radius: 12px !important;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.cifra__icono {
    align-self: flex-start;
    margin-bottom: 4px;
}

.cifra__valor {
    font-size: 1.45rem;
    font-weight: 700;
    line-height: 1.1;
    color: #203d89;
}

.cifra__etiqueta {
    font-size: .78rem;
    color: #5b6380;
}
</style>
